import { render, staticRenderFns } from "./ImportMappingsDataRow.vue?vue&type=template&id=0533f7f6&scoped=true"
import script from "./ImportMappingsDataRow.vue?vue&type=script&lang=js"
export * from "./ImportMappingsDataRow.vue?vue&type=script&lang=js"
import style0 from "./ImportMappingsDataRow.vue?vue&type=style&index=0&id=0533f7f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533f7f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0533f7f6')) {
      api.createRecord('0533f7f6', component.options)
    } else {
      api.reload('0533f7f6', component.options)
    }
    module.hot.accept("./ImportMappingsDataRow.vue?vue&type=template&id=0533f7f6&scoped=true", function () {
      api.rerender('0533f7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/import-mappings/ImportMappingsDataRow.vue"
export default component.exports